import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { getBlogComments, approveBlogComment, rejectBlogComment, deleteBlogComment } from '../../../actions';
import Button from '../../common/FormItems/Button';
import { Table, Icon, Label } from 'semantic-ui-react';

const CommentManageWrapper = styled.div`
  padding: 2rem;
  max-width: 1400px;
  margin: 0 auto;

  h1 {
    margin-bottom: 2rem;
  }

  .empty-state {
    text-align: center;
    padding: 3rem;
    color: #888;
  }
`;

const BlogCommentManage = () => {
  const dispatch = useDispatch();
  const { data: comments, isLoading } = useSelector((state) => state.blogComment);

  useEffect(() => {
    dispatch(getBlogComments());
  }, [dispatch]);

  const handleApprove = async (commentId) => {
    try {
      await dispatch(approveBlogComment(commentId));
      dispatch(getBlogComments());
    } catch (error) {
      console.error('Failed to approve comment:', error);
    }
  };

  const handleReject = async (commentId) => {
    try {
      await dispatch(rejectBlogComment(commentId));
      dispatch(getBlogComments());
    } catch (error) {
      console.error('Failed to reject comment:', error);
    }
  };

  const handleDelete = async (commentId) => {
    if (window.confirm('Are you sure you want to delete this comment?')) {
      try {
        await dispatch(deleteBlogComment(commentId));
        dispatch(getBlogComments());
      } catch (error) {
        console.error('Failed to delete comment:', error);
      }
    }
  };

  const commentsData = comments?.results || comments || [];

  return (
    <CommentManageWrapper>
      <h1>Manage Comments</h1>

      {isLoading ? (
        <div>Loading...</div>
      ) : commentsData.length === 0 ? (
        <div className="empty-state">
          <Icon name="comments outline" size="huge" />
          <p>No comments found</p>
        </div>
      ) : (
        <Table celled>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Author</Table.HeaderCell>
              <Table.HeaderCell>Comment</Table.HeaderCell>
              <Table.HeaderCell>Post</Table.HeaderCell>
              <Table.HeaderCell>Date</Table.HeaderCell>
              <Table.HeaderCell>Status</Table.HeaderCell>
              <Table.HeaderCell>Actions</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {commentsData.map(comment => (
              <Table.Row key={comment.id}>
                <Table.Cell>{comment.author?.username}</Table.Cell>
                <Table.Cell>{comment.content.substring(0, 100)}...</Table.Cell>
                <Table.Cell>{comment.post?.title}</Table.Cell>
                <Table.Cell>{new Date(comment.created_at).toLocaleDateString()}</Table.Cell>
                <Table.Cell>
                  {comment.is_approved ? (
                    <Label color="green">Approved</Label>
                  ) : (
                    <Label color="yellow">Pending</Label>
                  )}
                </Table.Cell>
                <Table.Cell>
                  {!comment.is_approved && (
                    <Button size="small" color="green" onClick={() => handleApprove(comment.id)}>
                      <Icon name="check" /> Approve
                    </Button>
                  )}
                  {comment.is_approved && (
                    <Button size="small" color="orange" onClick={() => handleReject(comment.id)}>
                      <Icon name="ban" /> Reject
                    </Button>
                  )}
                  <Button size="small" color="red" onClick={() => handleDelete(comment.id)}>
                    <Icon name="trash" /> Delete
                  </Button>
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      )}
    </CommentManageWrapper>
  );
};

export default BlogCommentManage;